import { cloneDeep, debounce } from 'lodash';
import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { FilterInterface } from '@/components/CustomFilter/FilterInterface';

@Component
export default class AbstractFilterMultiple extends Vue implements FilterInterface {

  // #region @PropSyncs

  @PropSync('filter')
  protected internalFilter!: string[];

  // #endregion

  // #region @Props

  @Prop({ default: () => [] })
  protected filterDefault!: string[];

  @Prop({ default: 'name' })
  protected filterStorageKey!: string;

  @Prop({ default: 'filters' })
  protected filtersStorageKey!: string;

  // #endregion

  // #region Props

  protected items: any[] = [];

  protected itemSearch: string = '';

  protected searchItemDebounce = debounce((searchInput: string) => this.getItems(searchInput), 400);

  // #endregion

  // #region Lifecycle hooks / Init

  protected mounted(): void {
    this.initialize();
  }

  protected async initialize(): Promise<void> {
    await this.getItems();
    this.initializeFilter();
    this.orderFilter();

    this.$emit('filter-loaded');
  }

  protected initializeFilter(): void {
    const filters = localStorage.getItem(`${this.$route.name}_${this.filtersStorageKey}_${this.filterStorageKey}`);

    this.internalFilterGetterSetter = filters && filters !== 'undefined'
      ? Object.values(JSON.parse(filters))
      : cloneDeep(this.filterDefault);
  }

  // #endregion

  // #region Handlers

  protected onOrderFilter(): void {
    this.orderFilter();
  }

  protected onResetFilter(): void {
    this.resetFilter();
  }

  // #endregion

  //#region Helpers

  protected orderFilter(): void {
    if(! this.items || ! this.internalFilterGetterSetter) { return; }

    const checkedItems = this.items.filter((item) => this.internalFilterGetterSetter.includes(item.id || ''));
    const uncheckedItems = this.items.filter((item) => ! this.internalFilterGetterSetter.includes(item.id || ''));

    this.items = [...checkedItems, ...uncheckedItems];
  }

  // PUBLIC
  public resetFilter(): void {
    this.internalFilterGetterSetter = cloneDeep(this.filterDefault);
  }

  //#endregion

  // #region API Requests

  protected async getItems(filter: string = '') {
    throw new Error('[METHOD NEEDS OVERRIDE] AbstractFilterMultiple.getItems method should be defined in the class that extends it');
  }

  // #endregion

  //#region Getters & Setters

  protected get internalFilterGetterSetter(): string[] {
    return this.internalFilter;
  }

  protected set internalFilterGetterSetter(value: string[]) {
    localStorage.setItem(`${this.$route.name}_${this.filtersStorageKey}_${this.filterStorageKey}`, JSON.stringify(value || []));
    this.internalFilter = value;
  }

  //#endregion

  // #region @Watchers

  @Watch('itemSearch')
  protected itemSearchChanged(item: string) {
    this.searchItemDebounce(item);
  }

  // #endregion
}
